"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeMultiSelectBadge = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../../../Icon");
require("./index.scss");
const BadgeMultiSelectBadge = (props) => {
    const { className, name = '', onClose } = props;
    const classNames = (0, classnames_1.default)('badge-multi-select-badge', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames, onClick: onClose },
        react_1.default.createElement("div", { className: 'badge-multi-select-badge__title' }, name),
        react_1.default.createElement("div", { className: 'badge-multi-select-badge__close' },
            react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
};
exports.BadgeMultiSelectBadge = BadgeMultiSelectBadge;
//# sourceMappingURL=index.js.map